import { useEffect, useState } from "react";
import { Check } from "lucide-react";
import { Button } from "./ui/button";
import { api } from "../lib/api";

const PERKS = ["Unlimited PDF downloads", "All 25 templates", "Clear, watermark-free preview", "Unlimited resumes"];

export const PlanCards = ({ onSelect, selected }) => {
  const [plans, setPlans] = useState([]);
  useEffect(() => { api.get("/plans").then((r) => setPlans(r.data)); }, []);

  return (
    <div className="grid md:grid-cols-2 gap-6">
      {plans.map((p) => {
        const best = p.id === "yearly";
        const active = selected === p.id;
        return (
          <div key={p.id} data-testid={`plan-card-${p.id}`}
            className={`relative rounded-2xl p-8 border transition-colors ${active ? "border-emerald-400 bg-emerald-500/10" : best ? "border-emerald-500/40 bg-gradient-to-b from-emerald-500/10 to-transparent" : "border-white/10 bg-[#12151E]"}`}>
            {best && <span className="absolute -top-3 left-8 text-[10px] font-mono uppercase tracking-widest bg-emerald-500 text-black rounded-full px-3 py-1">Save 67%</span>}
            <p className="text-sm text-slate-400">{p.label}</p>
            <p className="mt-2 font-display text-5xl font-extrabold tracking-tight" data-testid={`plan-price-${p.id}`}>
              ${p.usd}<span className="text-base font-medium text-slate-500">/{best ? "year" : "month"}</span>
            </p>
            <p className="mt-1 text-xs text-slate-500">Charged as ₹{p.inr} · {p.days} days of access</p>
            <ul className="mt-6 space-y-2.5">
              {PERKS.map((k) => (
                <li key={k} className="flex items-center gap-2 text-sm text-slate-300"><Check className="h-4 w-4 text-emerald-400" />{k}</li>
              ))}
            </ul>
            <Button onClick={() => onSelect(p.id)} data-testid={`plan-select-${p.id}`}
              className={`mt-8 w-full rounded-full h-11 font-semibold ${best || active ? "bg-emerald-500 text-black hover:bg-emerald-400 hover:text-black" : "bg-white/10 text-white hover:bg-white/20 hover:text-white"}`}>
              {active ? "Selected" : `Choose ${p.label.toLowerCase()}`}
            </Button>
          </div>
        );
      })}
    </div>
  );
};
